import React from 'react'
import PropTypes from 'prop-types'

const Filter = ({ className }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.4062 12.0938H2.8125M10.4062 12.0938C10.4062 12.8704 11.0358 13.5 11.8125 13.5C12.5892 13.5 13.2188 12.8704 13.2188 12.0938M10.4062 12.0938C10.4062 11.3171 11.0358 10.6875 11.8125 10.6875C12.5892 10.6875 13.2188 11.3171 13.2188 12.0938M15.1875 12.0938H13.2188M5.90625 5.90625H2.8125M5.90625 5.90625C5.90625 6.6829 6.53585 7.3125 7.3125 7.3125C8.08915 7.3125 8.71875 6.6829 8.71875 5.90625M5.90625 5.90625C5.90625 5.1296 6.53585 4.5 7.3125 4.5C8.08915 4.5 8.71875 5.1296 8.71875 5.90625M15.1875 5.90625H8.71875"
                stroke="#2D3034"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

Filter.propTypes = {
    className: PropTypes.string,
}

export default Filter
